const students = {
  edit: {
    tabs: {
      information: 'Information',
      notes: 'Notes',
      parents: 'Parents',
      caregivers: 'Caregivers',
      history: 'History',
      bookingHistory: 'Booking History'
    },
  },
  table: {
    headers: {
      createBtn: 'Create',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      homeAddress: 'Home Address',
      alternateAddress: 'Alternate Address',
      schoolAddress: 'School',
      createdAt: 'Created At',
    },
  },
  form: {
    header: {
      create: {
        title: 'Create',
      },

      update: {
        title: 'Update',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Submit',
        update: 'Submit',
      },
    },

    actions: {
      header: 'Actions',
      buttons: {
        resetPassword: 'Reset Password',
      },
    },

    create: {
      confirmButtonText: 'Submit',
      toasts: {
        success: 'Parent successfully created',
        error: 'An error occured while creating the parent',
      },
    },
    update: {
      formTabs: {
        informationTab: 'Information',
        notesTab: 'Notes',
      },

      activeStatus: {
        statusActive: 'Active',
        statusDeactivate: 'Inactive',
      },

      suspend: {
        actionActivate: 'Unsuspend',
        actionDeactivate: 'Suspend',
        suspendModal: {
          popupTitleDeactivation: 'Suspend Passenger',
          popupTitleActive: 'Suspend Reason',
          popupTitleUnsuspend: 'Unsuspend Reason',
          popupSubTitleDeactivation: 'Select the reason for the suspenssion',
          popupActionActive: 'Unsuspend Passenger',
          popupActionDeactivate: 'Suspend Passenger',
        },
      },
      toasts: {
        success: 'Parent successfully updated',
        error: 'An error occured while updating the parent',
        fetchError: 'Something went wrong, please try again.',
      },
    },
    sections: {
      profiles: {
        fields: {
          label: 'Profiles'
        }
      },
      attributes: {
        fields: {
          label: 'Profiles'
        }
      },
      personalDetails: {
        header: 'Personal Details',
        fields: {
          firstName: {
            label: 'First name',
          },
          lastName: {
            label: 'Last name',
          },
          email: {
            label: 'Email',
          },
          phone: {
            label: 'Phone',
          },
          additionalPhone: {
            label: 'Additional phone',
          },
          gender: {
            label: 'Gender',
          },
          dateBirth: {
            label: 'Date of Birth',
          },
        },
      },
      schoolDetails: {
        header: 'School Details',
        fields: {
          school: {
            label: 'School',
          },
          academicYear: {
            label: 'Academic Year',
            options: {
              default: 'Default',
              current: '2023-2024',
            },
          },
          level: {
            label: 'Level',
          },
          class: {
            label: 'Class',
          },
        },
      },
      profile: {
        header: 'Profiles',
        fields: {
          profile: 'Profiles',
        },
      },
      addresses: {
        header: 'Student Addresses',
        fields: {
          mainAddress: {
            label: 'Main Address',
          },
          alternateAddress: {
            label: 'Alternate Address',
          },
          level: {
            label: 'Level',
          },
          class: {
            label: 'Class',
          },
        },
      },
      linkParents: {
        linkedHeader: 'Linked Parents',
        listHeader: 'Parents List',
        noResultsLinkedTable: 'No parents linked yet',
        noResultsLinkedTableSubHeader: 'Add parents from the list below',
        noResultsListTable: 'No parents found',
        noResultsListTableSubHeader: 'We can\'t find any item matching your search',
        entity: 'Parents',

        parentsTable: {
          headers: {
            name: 'Name',
            address: 'Address',
            phone: 'Phone',
            email: 'Email',
          },
        },
      },

      linkCaregivers: {
        linkedHeader: 'Linked Caregivers',
        listHeader: 'Caregivers List',
        noResultsLinkedTable: 'No caregivers linked yet',
        noResultsLinkedTableSubHeader: 'Add caregivers from the list below',
        noResultsListTable: 'No caregivers found',
        noResultsListTableSubHeader: 'We can\'t find any item matching your search',
        add: 'Add',
        entity: 'Caregivers',

        caregiversTable: {
          headers: {
            name: 'Name',
            address: 'Address',
            phone: 'Phone',
            email: 'Email',
          },
        },
      },
    },
  },
};

export default students;
